import _sfc_main from "./component-library259.mjs";
import "./component-library260.mjs";
import normalizeComponent from "./component-library82.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("div", { staticClass: "extended-item-info", class: _setup.dynamicClass }, [_c("div", { staticClass: "product-image" }, [_setup.image ? _c(_setup.ImageElement, { attrs: { "src": _setup.image.small, "alt": _setup.image.name || "" } }) : _vm._e()], 1), _c("div", { staticClass: "item-configurator" }, [_c(_setup.SingleItemConfigurator, { attrs: { "bundle-item": _vm.bundleItem }, on: { "select-variant": (args) => _vm.$emit("select-variant", args) } })], 1)]);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "0546333c",
  null,
  null
);
const ExtendedItemInfo = __component__.exports;
export {
  ExtendedItemInfo as default
};
